export default "__VITE_ASSET__BeqQYG3c__"